import { useCallback, useMemo } from 'react';
import { Address, Client, mapClientToAddress, useAddress } from 'src/graphql';
import { DEFAULT_PAGINATION_LIMIT } from 'src/graphql/entities/search/use-search';
import { ConditionInput } from 'src/graphql/types';
import { useNotifications } from 'src/utils/hooks';

export const useClientSiteAssociation = (client: Partial<Client>) => {
  const { showSuccessAlert } = useNotifications();

  const { createClientToAddress } = useAddress();

  const associateSiteToClient = useCallback(
    async (newSite: Partial<Address> | null, filters?: ConditionInput[]) => {
      if (!newSite) {
        return;
      }

      const response = await createClientToAddress({
        client: mapClientToAddress(client),
        address: newSite,
        partnerId: client.partnerId,
        filters,
        limit: DEFAULT_PAGINATION_LIMIT,
      });

      if (!response) {
        return;
      }

      showSuccessAlert('Site was associated to the client');
    },
    [client, createClientToAddress, showSuccessAlert],
  );

  return useMemo(
    () => ({
      associateSiteToClient,
    }),
    [associateSiteToClient],
  );
};
